// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearButton_root__TR_kA","show":"ClearButton_show__zSF7y","icon":"ClearButton_icon__Yy7fz"};